import React from "react";
import { useSelector } from "react-redux";
import JobDetailsModal from "../../../features/jobs/components/JobDetailsModal";
import SignUpModal from "../../../features/auth/components/SignUpModal";
import SignUpEmployerModal from "../../../features/auth/components/SignUpEmployerModal";
import SignUpJobSeekerModal from "../../../features/auth/components/SignUpJobSeekerModal";
import ResetPasswordModal from "../../../features/auth/components/ResetPasswordModal";
import SuccessCompletionModal from "../../../features/employer/components/SuccessCompletionModal";
import DeleteJobConfirmModal from "../../../features/employer/components/DeleteJobConfirmModal";
import EditJobModal from "../../../features/employer/components/EditJobModal";
import AdminJobReviewModal from "../../../features/admin/components/AdminJobReviewModal";
import ChangePasswordSuccessModal from "../../../features/account/components/ChangePasswordSuccessModal";
import AccountDeletionRequestModal from "../../../features/admin/components/AccountDeletionRequestModal";
import JobUnavailableModal from "../../../features/jobs/components/JobUnavailableModal";
import CookieConsentModal from "../components/CookieConsentModal";
import TopUpModal from "../../../features/employer/components/TopUpModal";
import HowSocialMediaPromotionWorksModal from "../../../features/employer/components/HowSocialMediaPromotionWorksModal";
import AdminJobCloseModal from "../../../features/admin/components/AdminJobCloseModal";
import GettingStartedEmployerModal from "../../../features/employer/components/GettingStartedEmployerModal";
import MobileJobFiltersModal from "../../../features/jobs/components/MobileJobFiltersModal";
import ServiceSubmittingModal from "../../../features/employer/components/ServiceSubmittingModal";
import ErrorModal from "../components/ErrorModal";
import ToPaymentModal from "../../../features/payments/components/ToPaymentModal";
import PromptPayModal from "../../../features/payments/components/PromptPayModal";
import PromptNavigationModal from "../../../features/employer/components/PromptNavigationModal";
import AdminCompanyReviewModal from "../../../features/admin/components/AdminCompanyReviewModal";
import DeleteApplicationConfirmModal from "../../../features/employer/components/DeleteApplicationConfirmModal";
import StandardModal from "./StandardModal";

export const JOB_DETAILS_MODAL = "JobDetailsModal";
export const RESET_PASSWORD_MODAL = "ResetPasswordModal";
export const SIGN_UP_MODAL = "SignUpModal";
export const SIGN_UP_EMPLOYER_MODAL = "SignUpEmployerModal";
export const SIGN_UP_JOB_SEEKER_MODAL = "SignUpJobSeekerModal";
export const SERVICE_SUBMITTING_MODAL = "ServiceSubmittingModal";
export const SUCCESS_COMPLETION_MODAL = "SuccessCompletionModal";
export const DELETE_JOB_CONFIRM_MODAL = "DeleteJobConfirmModal";
export const EDIT_JOB_MODAL = "EditJobModal";
export const ADMIN_JOB_REVIEW_MODAL = "AdminJobReviewModal";
export const CHANGE_PASSWORD_SUCCESS_MODAL = "ChangePasswordSuccessModal";
export const ACCOUNT_DELETION_REQUEST_MODAL = "AccountDeletionRequestModal";
export const JOB_UNAVAILABLE_MODAL = "JobUnavailableModal";
export const COOKIE_CONSENT_MODAL = "CookieConsentModal";
export const HOW_SOCIAL_MEDIA_PROMOTION_WORKS_MODAL =
  "HowSocialMediaPromotionWorksModal";
export const ADMIN_JOB_CLOSE_MODAL = "AdminJobCloseModal";
export const GETTING_STARTED_EMPLOYER_MODAL = "GettingStartedEmployerModal";
export const MOBILE_JOB_FILTERS_MODAL = "MobileJobFiltersModal";
export const ERROR_MODAL = "ErrorModal";
export const TO_PAYMENT_MODAL = "ToPaymentModal";
export const PROMPT_PAY_MODAL = "PromptPayModal";
export const PROMPT_NAVIGATION_MODAL = "PromptNavigationModal";
export const ADMIN_COMPANY_REVIEW_MODAL = "AdminCompanyReviewModal";
export const DELETE_APPLICATION_CONFIRM_MODAL = "DeleteApplicationConfirmModal";
export const STANDARD_MODAL = "StandardModal";

export default function ModalManager() {
  const modalLookup = {
    JobDetailsModal,
    ResetPasswordModal,
    SignUpModal,
    SignUpEmployerModal,
    SignUpJobSeekerModal,
    ServiceSubmittingModal,
    SuccessCompletionModal,
    DeleteJobConfirmModal,
    EditJobModal,
    AdminJobReviewModal,
    ChangePasswordSuccessModal,
    AccountDeletionRequestModal,
    JobUnavailableModal,
    CookieConsentModal,
    TopUpModal,
    HowSocialMediaPromotionWorksModal,
    AdminJobCloseModal,
    GettingStartedEmployerModal,
    MobileJobFiltersModal,
    ErrorModal,
    ToPaymentModal,
    PromptPayModal,
    PromptNavigationModal,
    AdminCompanyReviewModal,
    DeleteApplicationConfirmModal,
    StandardModal,
  };
  const currentModal = useSelector((state) => state.modals);
  let renderedModal;
  if (currentModal) {
    const { modalType, modalProps } = currentModal;
    const ModalComponent = modalLookup[modalType];
    renderedModal = <ModalComponent {...modalProps} />;
  }

  return <span className="modal-manager">{renderedModal}</span>;
}
